import { render, staticRenderFns } from "./adjust-record-dialog.vue?vue&type=template&id=5f666218&scoped=true&"
import script from "./adjust-record-dialog.vue?vue&type=script&lang=js&"
export * from "./adjust-record-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f666218",
  null
  
)

export default component.exports